// extracted by mini-css-extract-plugin
export var table = "_tv-0";